import { render, staticRenderFns } from "./PageStep.vue?vue&type=template&id=61da933f"
import script from "./PageStep.vue?vue&type=script&lang=js"
export * from "./PageStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports